/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConfigValidationRequest {
    getFixupPrototypeFunction() { return ConfigValidationRequest.fixupPrototype; }

    static newInstance(model: Partial<ConfigValidationRequest>): ConfigValidationRequest {
        let obj = Object.assign(new ConfigValidationRequest(), model);
        ConfigValidationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConfigValidationRequest>): ConfigValidationRequest {
        if (!model) return null;
        return ConfigValidationRequest.newInstance(<ConfigValidationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConfigValidationRequest) {
        if (!obj) return;

        models.ConfigValidationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConfigValidationRequest): boolean {
        Object.setPrototypeOf(obj, ConfigValidationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Supported Policy engines are corestack_policy, aws_config and azure_policy
     */
    policy_engine: models.PolicyEngineType;

    /**
     * Supported Clouds for the respective Policy engine are AWS and Azure
     */
    service_name: models.CloudServiceName;

}
